import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import useGet from "./useGet";
import useUpdate from "./useUpdate";
import { EditActionContext } from "./EditActionContext";
import CategoryForm from "@beeldit/ecommerce/categories/components/CategoryForm";

function useEditAction(index: any): any {
  const get = useGet();
  const getFunction = (id: number) => get(id);

  /**
   * Form store success function definition
   */
  const onSuccessUpdate = () => {
    setShowModal(false);
    index(); // We pass the function to refresh the table on success
  };

  const update = useUpdate();
  const updateFunction = () => update(onSuccessUpdate);

  const contextInstance = useContext(EditActionContext);
  const { element, setShowModal } = contextInstance;

  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();

  /**
   * Creation and edition modal configuration definition
   */
  const modalConfig = {
    title: "edit_category",
    contextInstance: contextInstance,
    onSubmit: () => formRef.current?.formElement.current.requestSubmit(), //We pass the function for the submit of the modal
    size: "modal-lg",
  };

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      updateFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    context: EditActionContext,
    className: "category-form"
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <CategoryForm formConfig={formConfig} />
    </CrudModuleFactoryModal>
  );

  /** END EDIT FORM ACTION */

  return {
    getFunction,
    actionTemplate,
  };
}

export default useEditAction;
